
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/List', formData);
}

const Add = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/Add', formData);
}

const UpdateStatus = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/UpdateStatus', formData);
}

const UpdatePriority = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/UpdatePriority', formData);
}

const UpdateDepartment = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/UpdateDepartment', formData);
}

const UpdateResponsible = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/UpdateResponsible', formData);
}

const UpdateStartDate = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/UpdateStartDate', formData);
}

const UpdateEstimatedCompletionDate = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrder/UpdateEstimatedCompletionDate', formData);
}


const ServiceOrderService = {
    List,
    Add,
    UpdateStatus,
    UpdatePriority,
    UpdateDepartment,
    UpdateResponsible,
    UpdateStartDate,
    UpdateEstimatedCompletionDate
}

export default ServiceOrderService;